module.exports = __webpack_public_path__ + "img/xls.da993ffc.svg";